// extracted by mini-css-extract-plugin
export default {"why_block":"why_block___Qft10","flex_why":"flex_why____xw9W","one_why":"one_why___ofjb9","title":"title___v2wjV"};